export const PushNotification : Record<string, String> = {
  START: "0",
  IN_PROGRESS: "1",
  COMPLETED: "2",
};